import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { PayrollSetupList } from './PayrollSetupList'
import {
  FETCH_PAY_SCHEDULE_KEY,
  fetchAllPaySchedules,
  POST_PAY_SCHEDULE_KEY,
} from '../payrollActions'
import {
  GEP_ENROLL_PATHS,
  ONBOARDING_STEPS,
  useUpdatePayrollOnboardingStep,
} from '../helpers'
import { PrefilledNoticeContainer } from './PrefilledNoticeContainer'
import { getIsFetchingOrNotStarted } from '@/reducers/fetch'
import { PayrollError } from '../PayrollError'
import { selectPaySchedule } from '../payroll.selectors'
import { Button, Card, Separator, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useAnalyticsTrack } from '@/features/amplitude'
import { TypographyStyles } from '@/styles'
import { PayrollScheduleForm, SchedulePreview } from './PayrollScheduleForm'

export const PayrollEnrollSchedule = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const track = useAnalyticsTrack()
  useUpdatePayrollOnboardingStep(ONBOARDING_STEPS.payrollSchedule)

  const paySchedule = useReselector(selectPaySchedule)
  const loading = useReselector(
    getIsFetchingOrNotStarted,
    FETCH_PAY_SCHEDULE_KEY
  )

  useEffect(() => {
    dispatch(fetchAllPaySchedules())
  }, [dispatch])

  return (
    <div>
      <Card>
        <div className="flex flex-col gap-6">
          <Text variant={TypographyStyles.DISPLAY_XS}>Setting Up Payroll</Text>

          <Separator />

          <PrefilledNoticeContainer />
          <PayrollError fetchKey={POST_PAY_SCHEDULE_KEY} />

          <div className="flex flex-col lg:flex-row gap-8">
            <div className="lg:w-9/12 flex flex-col gap-6">
              {!paySchedule && !loading && (
                <PayrollScheduleForm
                  onSuccess={() => {
                    track('completed payroll step - set pay schedule')
                    navigate(GEP_ENROLL_PATHS.flow)
                  }}
                  onCancel={() => navigate(GEP_ENROLL_PATHS.employeeBank)}
                  saveText="Save & Continue"
                />
              )}

              {paySchedule && (
                <div className="flex flex-col gap-6">
                  <SchedulePreview
                    firstPayDate={paySchedule.anchor_pay_date}
                    frequency={paySchedule.frequency}
                  />

                  <div className="flex flex-col sm:flex-row justify-between gap-4">
                    <Button
                      variant="secondary"
                      onClick={() => navigate(GEP_ENROLL_PATHS.employeeBank)}
                      className="sm:w-1/2"
                    >
                      Back
                    </Button>
                    <div className="hidden sm:block sm:w-[16.666%]" />
                    <Button
                      onClick={() => navigate(GEP_ENROLL_PATHS.flow)}
                      className="sm:w-1/2"
                    >
                      Save & Continue
                    </Button>
                  </div>
                </div>
              )}
            </div>

            <div className="lg:w-7/12">
              <PayrollSetupList />
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}
